import styled from "styled-components";
import BackMembers from '../../imagens/backMembers.png';
import { FaRegWindowClose, FaRegSquare, FaRegCheckSquare } from 'react-icons/fa';

const Container = styled.div`
    min-height: 100vh;
    color: #fff;
    background: url(${BackMembers});
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: right;
    background-position-y: bottom;
`;
const FutInfo = styled.div`
    text-align: center;
    padding: 24px 16px;
`;
const Title = styled.h1`
    font-size: 24px;
    font-weight: bold;
`;
const SubInfo = styled.p`
    margin-top: 4px;
    font-size: 16px;
`;
const MembersSection = styled.section`
    margin-top: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Ul = styled.ul`
    padding: 0;
    margin: 0;
    width: 500px;
    max-width: 80vw;
    max-height: 60vh;
    overflow: auto;
    padding-right: 10px;
`
const Li = styled.li`
    display: flex;
    justify-content: space-between;
    padding: 15px 30px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border: 1px solid rgba(206, 206, 206, 0.52);
    border-radius: 12px;
    color: white;
    font-size: 16px;
    margin-bottom: 15px;
`
const Name = styled.div`
    display: flex;
    align-items: center;

    svg {
        margin-right: 15px;
        cursor: pointer;

        &.checked {
            display: none;
        }
    }
`
const Options = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;

    svg {
        margin-left: 20px;
    }
`
const infos = ['Anderson Lavorato' , 'Marcão' , 'Juan' , 'Douglas' , 'Miguel' , 'Jonny' , 'Peterson' , 'Waltin' , 'Gabriel' , 'Rafa', 'Rodrigo', 'Luizinho', 'japa', 'Gustavo', 'Henrique', 'Amauri', 'Léo', 'Dudu', 'Jean', 'Felipe Cruz'];

function ConfirmSection() {
    return(
        <>
             <Container>
                <FutInfo>
                    <Title>Confirmados</Title>
                    <SubInfo>Quantidade:</SubInfo>
                </FutInfo>
                <MembersSection>
                            <Ul>
                                {infos.map((item, index) => (
                                    <Li>
                                        <Name>
                                            <FaRegSquare className="checkNull"/>
                                            <FaRegCheckSquare className="checked"/>
                                            {item}
                                        </Name>
                                        <Options>
                                            <FaRegWindowClose  />
                                        </Options>
                                    </Li>
                                ))}
                            </Ul>
                </MembersSection>
            </Container>
        </>
    )
}

export default ConfirmSection;